"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeCategory = void 0;
/* Auto-generated from type-schema.proto */
var TypeCategory;
(function (TypeCategory) {
    TypeCategory[TypeCategory["Undefined"] = 0] = "Undefined";
    TypeCategory[TypeCategory["Schema"] = 1] = "Schema";
    TypeCategory[TypeCategory["Boolean"] = 2] = "Boolean";
    TypeCategory[TypeCategory["Number"] = 3] = "Number";
    TypeCategory[TypeCategory["String"] = 4] = "String";
    TypeCategory[TypeCategory["Buffer"] = 5] = "Buffer";
    TypeCategory[TypeCategory["Function"] = 6] = "Function";
})(TypeCategory = exports.TypeCategory || (exports.TypeCategory = {}));
//# sourceMappingURL=type-schema.js.map